// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7bbc2eb0","977":"ab9cc940"}[chunkId] + ".chunk.js";
};